module.exports = __webpack_public_path__ + "img/partner3.372d0f04.png";